import React from 'react';

function Blocke({ language }) {
  // Content for both English and Hindi
  const content = {
    en: [
      {
        title: "The Divine Vision",
        image: "images/main-attractions/block-e/block-e-1.png",
        description: `Before you stands a grand structure of bells, forming the divine image of Lord Krishna playing his flute. Their melodious sound and Krishna’s form symbolize cosmic harmony, divine love, and inner peace, nurturing both mind and body.`,
        
      },
      {
        title: "Eternal Wisdom of the Gita",
        image: "images/main-attractions/block-e/block-e-2.png",
        description: `At Kurukshetr, Lord Krishna revealed the timeless wisdom of the Bhagavad Gita to Arjun. When Arjun faltered, seeing his elders and kin before him, Krishna urged him to rise above doubt and  recognize duty and righteousness. Through verses on karma, self-realization, and dharma, Krishna gave humanity the universal path of righteous living. The Gita remains a guiding light for all ages.`,
        label: "Main Attraction",
      },
      {
        title: "The Gita Unveiled",
        image: "images/main-attractions/block-e/block-e-3.png",
        description: `In this interactive zone, you may ask your questions. Lord Krishna’s timeless wisdom from the Bhagavad Gita guides every answer. From duty and courage to life's deepest mysteries, the Gita speaks to all. Let this eternal dialogue enlighten your mind and soul.`,
        label: "Main Attraction",
      },
      {
        title: "Krishna’s Eternal Blessing",
        image: "images/main-attractions/block-e/block-e-4.png",
        description: `Behold Krishna in his divine form — the eternal guide of righteousness. His blessings illuminate the path of dharma for every soul that stands before him.`,
        label: "Main Attraction",
      },
      {
        title: "Essence of the Mahabharat",
        image: "images/main-attractions/block-e/block-e-5.png",
        description: `In this zone, the essence of the Bhagavad Gita unfolds. Selected shlokas from all 18 chapters reveal its timeless wisdom. Each verse carries a message of duty, knowledge, devotion, and truth. Together, they form the universal guide to life and righteousness.`,
      },
      // Add other items here...
    ],
    hi: [
      {
        title: "कृष्ण दर्शन",
        image: "images/main-attractions/block-e/block-e-1.png",
        description: `आपके सामने घंटियों से बनी एक भव्य संरचना है, जो भगवान कृष्ण को बाँसुरी बजाते हुए दर्शाती है। इनकी मधुर ध्वनि और कृष्ण का स्वरूप ब्रह्मांडीय संतुलन, दिव्य प्रेम और आंतरिक शांति का प्रतीक है, जो मन और शरीर को संबल देता है।`,
      },
      {
        title: "गीता का शाश्वत ज्ञान",
        image: "images/main-attractions/block-e/block-e-2.png",
        description: `कुरुक्षेत्र की रणभूमि पर भगवान श्रीकृष्ण ने अर्जुन को श्रीमद्भगवद्‌गीता का अमर ज्ञान दिया। जब अर्जुन अपने परिजनों को सामने देखकर विचलित हुए, तब कृष्ण ने उन्हें मोह और संशय त्यागकर धर्म और कर्तव्य को पहचानने का उपदेश दिया। कर्म, आत्मा और धर्म के गूढ़ सिद्धांतों के माध्यम से कृष्ण ने मानवता को जीवन का शाश्वत मार्ग दिखाया। गीता आज भी मानवता को दिशा और प्रकाश देती है।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "गीता साक्षात्कार",
        image: "images/main-attractions/block-e/block-e-3.png",
        description: `इस संवादात्मक क्षेत्र में आप अपने प्रश्न पूछ सकते हैं। भगवान कृष्ण का शाश्वत ज्ञान, भगवद्‌गीता से, हर उत्तर में आपका मार्गदर्शन करेगा। धर्म, साहस और जीवन के गूढ़ रहस्यों का उत्तर गीता में निहित है। यह अमर संवाद आपके मन और आत्मा को आलोकित करेगा।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "कृष्ण - आशीष",
        image: "images/main-attractions/block-e/block-e-4.png",
        description: `यहाँ श्रीकृष्ण अपने दिव्य रूप में विराजमान हैं- धर्म के शाश्वत मार्गदर्शक । उनके आशीर्वाद से हर दर्शक का मार्ग आलोकित होता है।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "महाभारत का सार",
        image: "images/main-attractions/block-e/block-e-5.png",
        description: `इस क्षेत्र में श्रीमद्भगवद्गीता का सार प्रस्तुत है। सभी 18 अध्यायों से चुने गए श्लोक इसका शाश्वत ज्ञान प्रकट करते हैं। हर श्लोक कर्तव्य, ज्ञान, भक्ति और सत्य का संदेश देता है। ये सभी मिलकर जीवन और धर्म का सार्वभौमिक मार्ग दिखाते हैं।`,
      },
      // Add other items here...
    ],
  };

  return (
    <div className="main_attractions_list">
      {content[language].map((item, index) => (
        <div className="list_item" id={`ma-blocke-${index}`} key={index}>
          <div className="attraction_image">
            <img src={item.image} alt={item.title} />
          </div>
          <div className="attranction_details">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            {item.label && <span className="main-attraction-label">{item.label}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Blocke;
